import * as React from "react";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {RootState} from "../../../store/reducer/root/RootState";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import DictionarySortableItemsList from "../common/DictionarySortableItemsList";
import {createLeadType, updateLeadType, updateLeadTypesSortOrder} from "../../../store/action/leadType/leadType";

interface ReduxProps {
	/**
	 * All lead types.
	 */
	leadTypes: DictionaryItem[];
}

interface DispatchProps {
	/**
	 * Sort order update callback.
	 * @param {DictionaryItem[]} leadTypes
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateSortOrder: (leadTypes: DictionaryItem[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Create lead type.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createLeadType: (leadType: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Update lead type.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateLeadType: (ltId: string, leadType: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = ReduxProps & DispatchProps;

/**
 * Lead categories config view.
 */
class LeadTypesConfigView extends React.Component<Props, {}> {

	render() {
		return (
			<DictionarySortableItemsList title={"Lead Type"}
										 items={this.props.leadTypes}
										 updateItem={this.props.updateLeadType}
										 createItem={this.props.createLeadType}
										 updateSortOrder={this.props.updateSortOrder}/>
		)
	}

}

function mapStateToProps(state: RootState) {
	return {
		leadTypes: [].concat(state.leadType.leadTypes.getOrElse([]))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateSortOrder: (leadTypes: DictionaryItem[], onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateLeadTypesSortOrder(leadTypes, onSuccess, onFailure)),
		createLeadType: (leadType: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createLeadType(leadType, onSuccess, onFailure)),
		updateLeadType: (ltId: string, leadType: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateLeadType(ltId, leadType, onSuccess, onFailure))
	}
}

export default connect<ReduxProps, DispatchProps, null>(mapStateToProps, mapDispatchToProps)(LeadTypesConfigView)